<template>
  <dialog-v2
    :show="show"
    :title="title"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-tabs
            v-model="selectedTab"
            grow>
            <v-tabs-slider color="k-orange-linear"></v-tabs-slider>
            <v-tab
              v-for="(tab, i) in tabs"
              :key="`tab-${i}`"
              ripple>
              {{ tab.title }}
            </v-tab>
            <v-tab-item
              v-for="(tab, i) in tabs"
              :key="`tab-item-${i}`">
              <template v-if="tab.type !== 'sms' && tab.type !== 'afternoon_text'">
                <template-textarea
                  v-model="form.text"
                  v-validate="'required'"
                  data-vv-name="text"
                  data-vv-scope="textDialog"/>
                <small class="red--text" v-if="errors.has('textDialog.text')">
                  Debe ingresar un texto
                </small>
              </template>
              <template-textarea
                v-else-if="tab.type === 'sms'"
                v-model="(form.sms[(i - (tabs.length - (data.sms || []).length))] || {}).text"
                v-validate="(form.sms[(i - (tabs.length - (data.sms || []).length))] || {}).enabled ? 'required' : ''"
                :data-vv-name="tab.name"
                data-vv-scope="textDialog"/>
              <template-textarea
                v-else-if="tab.type === 'afternoon_text'"
                v-model="form.afternoon_text"/>
              <v-layout v-if="tab.name === 'text' && sendCallCenterOption" row wrap mt-3>
                <v-flex xs12>
                  <v-switch
                    v-model="form.send_call_center"
                    label="Derivar llamadas al call center"
                    class="k-blue-linear-text"
                    :hide-details="true"/>
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    v-if="form.send_call_center"
                    v-model="form.call_center_number"
                    label="Ingrese numero"
                    color="black"
                    hint="Si desea que la llamada se derive a un call externo, ingrese el numero aqui"
                    :persistent-hint="true"/>
                </v-flex>
              </v-layout>
              <v-layout v-if="tab.type === 'sms' && form.sms.length" row wrap align-center mt-3>
                <v-flex xs12>
                  <v-switch
                    v-model="form.sms[(i - (tabs.length - data.sms.length))].enabled"
                    label="Activo"
                    class="k-blue-linear-text"
                    :hide-details="true"/>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';
import TemplateTextarea from '@/components/bot_v4/Detail/TemplateTextarea';
import { setTimeout } from 'timers';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    sendCallCenterOption: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    DialogV2,
    TemplateTextarea,
  },
  data() {
    const emptyForm = {
      text: '',
      afternoon_text: '',
      send_call_center: false,
      sms: [],
    };
    return {
      tmp: false,
      emptyForm,
      form: {
        ...emptyForm,
      },
      selectedTab: '0',
    };
  },
  computed: {
    tabs() {
      let tmp = [
        {
          name: 'text',
          title: 'Texto',
        }
      ];
      if (!Object.keys(this.data).length || this.data.hasOwnProperty('afternoon_text')) {
        tmp = [
          {
            name: 'text',
            type: 'text',
            title: 'Texto de la mañana',
          },
          {
            name: 'afternoon_text',
            type: 'afternoon_text',
            title: 'Texto de la tarde',
          },
        ];
      }
      return [
        ...tmp,
        ...(this.data.sms || []).map(item => ({
          ...item,
          type: 'sms',
          name: `sms_${item.status_id}`,
          title: `SMS ${this.$store.getters.status(item.status_id).status}`,
        })),
      ];
    },
  },
  methods: {
    save() {
      this.$validator.validateAll('textDialog').then((validation) => {
        if (validation) {
          this.$emit('save', this.form);
          this.selectedTab = String(this.tabs.findIndex(item => item.name === errors[0].field));
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.selectedTab = '0';
        this.form = {
          ...this.data,
        };
        this.$validator.errors.remove('text', 'textDialog');
      } else {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          this.$validator.errors.remove('text', 'textDialog');
        }, 200);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/bot_v4/Detail/TextDialog.vue